
import { Vue } from "vue-class-component";
import { LastBalanceController } from "@/app/ui/controllers/LastBalanceController";

export default class LastBalanceV2 extends Vue {
  // Tabs
  tabs = [
    { name: "balance-pos", title: "POS" },
    { name: "balance-client", title: "Klien" },
    { name: "balance-cod-client", title: "Klien COD" }
  ];

  changeTabs(value: string) {
    LastBalanceController.setSearch("");
    this.$router.push({
      name: value
    });
  }

  isTabActive(name: string) {
    return name === this.$route.name;
  }
}
